export default "__VITE_ASSET__Cb2qRth7__"